import { List, Typography } from 'antd';
import { logo, SearchIcon2 } from 'assets';
import { InputSearch, Pagination } from 'components/common';
import { useContactCustomersPaging } from 'hooks/contacts';
import { customerLookupMessages } from 'messages/customer-lookup.message';
import React from 'react';
import { ContactCustomerDto } from 'types';
import { ProfileInfo } from './CustomerLookupContactHistoryItem';

type ContactCustomersTabProps = {
  contactId: number;
  handleCustomerCodeClick?: (customerCode: string) => void;
};

const ContactCustomerItem: React.FC<{ item: ContactCustomerDto; onClick?: () => void }> = ({ item, onClick }) => {
  return (
    <div className='group cursor-pointer px-6 hover:bg-colorBgItemHover' onClick={onClick}>
      <div className='flex h-20 cursor-pointer items-center gap-4 border-b py-4 group-hover:border-b-0'>
        <div>
          <div className='h-12 w-12'>
            <img src={logo} className='h-full w-full' />
          </div>
        </div>
        <div className='flex flex-col gap-1'>
          <div className='flex items-center gap-1.5'>
            <Typography.Text className='font-semibold'>{item.customerCode}</Typography.Text>
            {item.isOwner ? (
              <span className='rounded-md bg-colorPrimary px-1.5 text-xs font-semibold uppercase leading-5 text-white'>
                {customerLookupMessages.isOwner}
              </span>
            ) : null}
          </div>

          {item.customer && (
            <div className='overflow-hidden'>
              {
                <ProfileInfo
                  className='text-subTextColor2'
                  items={[
                    {
                      icon: null,
                      value: item.customer.customerName
                    },
                    { icon: null, value: item.customer.customerAddress }
                  ]}
                />
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const ContactCustomersTab: React.FC<ContactCustomersTabProps> = ({ contactId, handleCustomerCodeClick }) => {
  const [keyword, setKeyword] = React.useState<string>('');

  const { contactCustomers, handleChangePage, pageIndex, pageSize, count, isLoading } = useContactCustomersPaging({
    contactId,
    keyword
  });

  return (
    <div>
      <div className='mb-2 flex flex-col items-center justify-center gap-2'>
        <InputSearch
          prefixCls='input-search-v3'
          value={keyword}
          className='w-[400px]'
          onChange={setKeyword}
          allowClear
          prefix={<SearchIcon2 style={{ color: '#868d97' }} />}
        />
      </div>
      <div className='flex h-[calc(100vh-278px)] max-h-[calc(100vh-278px)] flex-col items-center gap-[22px] overflow-auto pb-5'>
        <List
          className='mt-2 w-full'
          rowKey={(item) => `contact-customer-${item.customerCode}`}
          dataSource={contactCustomers}
          renderItem={(item) => (
            <ContactCustomerItem
              onClick={() => handleCustomerCodeClick?.(item.customerCode)}
              key={item.customerCode}
              item={item}
            />
          )}
          loading={isLoading}
        />
        <div className='mt-auto'>
          <Pagination
            count={count}
            loading={isLoading}
            currentPage={pageIndex}
            pageSize={pageSize}
            handleChangePage={(pageIndex: number) => handleChangePage(pageIndex)}
          />
        </div>
      </div>
    </div>
  );
};
export default ContactCustomersTab;
